function getValueByLanguage(obj, key, language) {
  if (!obj) {
    return '';
  }
  const translatedKey = `${key}-${language}`;
  if (Object.hasOwn(obj, translatedKey)) {
    return obj[translatedKey];
  } else {
    return obj[key];
  }
}

export { getValueByLanguage };
